export default __webpack_public_path__ + "static/young-toddler5-bdead95c969acb9c7caabc30eda2e575.jpg";